import { css } from 'styled-components';

export const display2Xs = css`
    font-family: var(--carina-font-family-display, Inter);
    font-size: var(--carina-font-size-display-2xs, 21px);
    font-style: normal;
    font-weight: var(--carina-font-weight-display, 600);
    line-height: var(--carina-line-height-display-2xs, 28px); /* 133.333% */
    letter-spacing: 0;
`;

export const displayXs = css`
    font-family: var(--carina-font-family-display, Inter);
    font-size: var(--carina-font-size-display-xs, 24px);
    font-style: normal;
    font-weight: var(--carina-font-weight-display, 600);
    line-height: var(--carina-line-height-display-xs, 32px);
    letter-spacing: 0;
`;

export const displaySm = css`
    font-family: var(--carina-font-family-display, Inter);
    font-size: var(--carina-font-size-display-sm, 28px);
    font-style: normal;
    font-weight: var(--carina-font-weight-display, 600);
    line-height: var(--carina-line-height-display-sm, 36px); /* 128.571% */
    letter-spacing: 0;
`;

export const bodyRegularXs = css`
    font-family: var(--carina-font-family-body, Inter);
    font-size: var(--carina-font-size-body-xs, 13px);
    font-style: normal;
    font-weight: var(--carina-font-weight-body, 400);
    line-height: var(--carina-line-height-body-xs, 20px); /* 153.846% */
    letter-spacing: 0;
`;

export const bodyRegularSm = css`
    font-family: var(--carina-font-family-body, Inter);
    font-size: var(--carina-font-size-body-sm, 14px);
    font-style: normal;
    font-weight: var(--carina-font-weight-body, 400);
    line-height: var(--carina-line-height-body-sm, 20px); /* 142.857% */
    letter-spacing: 0;
`;

export const bodyRegularMd = css`
    font-family: var(--carina-font-family-body, Inter);
    font-size: var(--carina-font-size-body-md, 14px);
    font-style: normal;
    font-weight: var(--carina-font-weight-body, 400);
    line-height: var(--carina-line-height-body-md, 20px); /* 142.857% */
    letter-spacing: 0;
`;

export const bodyRegularLg = css`
    font-family: var(--carina-font-family-body, Inter);
    font-size: var(--carina-font-size-body-lg, 16px);
    font-style: normal;
    font-weight: var(--carina-font-weight-body, 400);
    line-height: var(--carina-line-height-body-lg, 24px); /* 150% */
    letter-spacing: 0;
`;

export const bodyRegularXl = css`
    font-family: var(--carina-font-family-body, Inter);
    font-size: var(--carina-font-size-body-xl, 21px);
    font-style: normal;
    font-weight: var(--carina-font-weight-body, 400);
    line-height: var(--carina-line-height-body-xl, 28px); /* 133.333% */
    letter-spacing: 0;
`;

export const bodyBoldMd = css`
    font-family: var(--carina-font-family-body, Inter);
    font-size: var(--carina-font-size-body-md, 14px);
    font-style: normal;
    font-weight: var(--carina-font-weight-display, 600);
    line-height: var(--carina-line-height-body-md, 20px); /* 142.857% */
`;

export const header6 = css`
    font-family: var(--carina-font-family-display, Inter);
    font-size: var(--carina-font-size-header-6, 18px);
    font-style: normal;
    font-weight: var(--carina-font-weight-display, 600);
    line-height: var(--carina-line-height-header-6, 24px); /* 133.333% */
    letter-spacing: 0;
`;

export const link = css`
    color: var(--carina-text-color-primary, #723d9e);
    font-feature-settings: 'liga' off, 'clig' off;
    text-decoration: auto;

    ${bodyRegularMd}

    :hover {
        color: var(--carina-text-color-primary-hover, #49265f);
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
    }

    :active {
        color: var(--carina-text-color-primary-active, #723d9e);
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
    }

    :where([data-disabled]) {
        color: var(--carina-text-color-disabled, #dddde3);
        pointer-events: none;
    }
`;
